import React from 'react'
import Iconify from '../../../../Iconify'
import visa from './brands/visa.svg'
import mastercard from './brands/mastercard.svg'
import amex from './brands/amex.svg'
import styles from './card-number.module.css'

const icons = {
  mastercard,
  visa,
  amex,
  maestro: mastercard
}

export const getIconBrand = (paymentCardType, size = 40) => {
  const src = paymentCardType && icons[paymentCardType]
  if (src) {
    return (
      <img
        src={src}
        alt="Tarjeta"
        width={size}
        height={size}
        className={styles.brandIcon}
      />
    )
  }
  return <Iconify icon="teenyicons:credit-card-solid" style={{ fontSize: size, color: '#3e3e3e' }} />
}
